/**
 * Utility to extract BFF antiforgery token from HTML
 * The BFF injects these values into a JSON script tag at page load
 */

/**
 * Get the antiforgery data from the HTML script tag
 * @returns {{token: string|null, headerName: string}} The antiforgery data
 */
const getAntiforgeryData = () => {
  const scriptElement = document.getElementById("antiforgery-data");
  if (!scriptElement) {
    console.warn("Antiforgery data script not found in HTML");
    return { token: null, headerName: "_af" };
  }

  try {
    const data = JSON.parse(scriptElement.textContent || "{}");

    // Check if BFF has replaced the placeholders
    if (data.token === "afTknToReplace" || !data.token) {
      console.warn("Antiforgery token not initialized by BFF");
      return { token: null, headerName: data.headerName || "_af" };
    }

    if (data.headerName === "afHdrNmToReplace" || !data.headerName) {
      console.warn(
        "Antiforgery header name not initialized by BFF, using default: _af"
      );
      return { token: data.token, headerName: "_af" };
    }

    return { token: data.token, headerName: data.headerName };
  } catch (error) {
    console.error("Failed to parse antiforgery data:", error);
    return { token: null, headerName: "_af" };
  }
};

/**
 * Get the antiforgery token value from the HTML
 * @returns {string|null} The antiforgery token value or null if not found
 */
export const getAntiforgeryToken = () => {
  const { token } = getAntiforgeryData();
  return token;
};

/**
 * Get the antiforgery header name from the HTML
 * @returns {string} The antiforgery header name (defaults to '_af')
 */
export const getAntiforgeryHeaderName = () => {
  const { headerName } = getAntiforgeryData();
  return headerName;
};
